import { createJsonbObjectEditor } from "../_resources/jsonbObjectEditor.js";
import { createJsonbTableEditor } from "../_resources/jsonbTableEditor.js";

export default function ({ dom, message, filePicker }) {

  let editorLogos = null;
  let editorLinks = null;
  let editorProps = null;

  const render = (pageId, base_url, hasPageEditAccess) => {
    dom.html("");
    const domLogos = dom.append("section").class("footer-logos-editor");
    const domLinks = dom.append("section").class("footer-links-editor");
    const domProperties = dom.append("section").class("footer-props-editor");

    editorLogos = createJsonbTableEditor({
      dom: domLogos,
      message,
      heading: "Footer Logos",
      table: 'pages',
      recordId: pageId,
      fieldName: 'footer_logos',
      base_url,
      headers: ['Image', 'Link and style'],
      columns: [
        { field: 'image', type: 'image', label: 'Image', required: true, columnIndex: 0, comment: `uploaded file, global https url or asset/path` },
        { field: 'url', type: 'url', label: 'Link', columnIndex: 1 },
        { 
          field: 'style', type: 'kvp', label: 'Style', columnIndex: 1,
          keys: ['height', 'margin-bottom'],
          comment: ["example: 100px", "example: 20px"] 
        }
      ],
      allowReorder: hasPageEditAccess,
      allowAdd: hasPageEditAccess,
      allowEdit: hasPageEditAccess,
      allowDelete: hasPageEditAccess,
      filePicker
    });

    editorLinks = createJsonbTableEditor({
      dom: domLinks,
      message,
      heading: "Footer Links",
      table: 'pages',
      recordId: pageId,
      fieldName: 'footer_links',
      headers: ['Text and link', 'Line'],
      columns: [
        { field: 'text', type: 'text', label: '文 Text', required: true, columnIndex: 0, comment: "set directly here or use a translated 文 Text" },
        { field: 'url', type: 'url', label: 'Link', required: true, columnIndex: 0 },
        { field: 'line', type: 'options', values: ["one","two"], label: 'Line', required: true, columnIndex: 1 }
      ],
      allowReorder: hasPageEditAccess,
      allowAdd: hasPageEditAccess,
      allowEdit: hasPageEditAccess,
      allowDelete: hasPageEditAccess
    });

    editorProps = createJsonbObjectEditor({
      dom: domProperties,
      message,
      heading: "Footer Settings",
      table: 'pages',
      recordId: pageId,
      fieldName: 'theme_components',
      subPath: 'Footer',
      schema: {
        "heading": {type: "text", label: "文 Heading"},
        "caption": {type: "text", label: "文 Caption"},
        "style": { type: 'kvp', label: 'Style', keys: ['display'], comment: ["flex, block or none"] },
      },
      allowEdit: hasPageEditAccess
    });

    editorLogos.load();
    editorLinks.load();
    editorProps.load();
  };

  return { render };
}

